import React from 'react'
import { AddMasterDataProps } from '../category/Index'
import { Title } from '../../../../../stories/Title/Title';
import { Operation } from '../../../../../utils/Enum.types';
import InputHoc from '../../../../common/Input/Index';
import { Keys } from '../../../../../utils/Enum.keys';

const Add = ({
  formData,
  handleValueChange,
  meta,
  operation,
}: AddMasterDataProps) => {
  const submitButton = document.getElementsByClassName("submit");

  return (
    <div className="master-data__add">
    <Title variant="subtitle1">{`${
      operation === Operation.CREATE ? "Add" : "Update"
    } Group`}</Title>
    <div className="master-data__add--form">
      <InputHoc
        LabelName={`Grouping Description`}
        values={formData.groupName}
        name="groupName"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          handleValueChange(e, meta)
        }
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.key === Keys.ENTER) {
            submitButton.length && (submitButton[0] as HTMLButtonElement).focus();
          }
        }}
        autoFocus
        required
      />
    </div>
  </div>
  )
}

export default Add
